import { useEffect } from "react";

/**
 * Adds a `.is-visible` class to any node with `data-reveal` once it enters the viewport.
 * Lightweight scroll-triggered reveal without external deps.
 */
export default function useReveal() {
    useEffect(() => {
        if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;
        const els = document.querySelectorAll("[data-reveal]");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        els.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);
}
